export const STAGES = [
  { key: 'new', label: 'New', tone: 'bg-sky-100 text-sky-800' },
  { key: 'review', label: 'Review', tone: 'bg-amber-100 text-amber-800' },
  { key: 'interview', label: 'Interview', tone: 'bg-violet-100 text-violet-800' },
  { key: 'trial_clean', label: 'Trial Clean', tone: 'bg-orange-100 text-orange-800' },
  { key: 'decision', label: 'Decision', tone: 'bg-zinc-200 text-zinc-800' },
  { key: 'offer', label: 'Offer', tone: 'bg-emerald-100 text-emerald-800' },
  { key: 'onboarding', label: 'Onboarding', tone: 'bg-teal-100 text-teal-800' },
  { key: 'hired', label: 'Hired', tone: 'bg-green-200 text-green-900' },
];
export const SIDE_STAGES = [
  { key: 'talent_pool', label: 'Talent Pool', tone: 'bg-blue-50 text-blue-800' },
  { key: 'rejected', label: 'Rejected', tone: 'bg-red-100 text-red-800' },
  { key: 'withdrawn', label: 'Withdrawn', tone: 'bg-zinc-100 text-zinc-600' },
];
export const ALL_STAGES = [...STAGES, ...SIDE_STAGES];
export const stageMeta = (key) => ALL_STAGES.find((s) => s.key === key) || { key, label: key, tone: 'bg-zinc-100 text-zinc-700' };

export const SOURCES = ['Website', 'Instagram', 'Facebook', 'Indeed', 'Nextdoor', 'Google', 'Referral', 'Other', 'Phone inquiry', 'Email inquiry', 'Walk-in'];
export const ARRANGEMENTS = ['W-2 employee', '1099 independent contractor', 'I’d like to discuss'];
export const WORK_TYPES = ['House cleaning', 'Commercial cleaning', 'Both'];
export const INQUIRY_CHANNELS = [['phone', 'Phone call'], ['email', 'Email'], ['referral', 'Referral'], ['walk_in', 'Walk-in'], ['other', 'Other']];

export const fmtDate = (iso) => (iso ? new Date(iso).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }) : '—');
export const fmtDateTime = (iso) => (iso ? new Date(iso).toLocaleString('en-US', { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' }) : '—');
export const fullName = (a) => `${a.first_name || ''} ${a.last_name || ''}`.trim();

export const MESSAGE_TEMPLATES = {
  interview_invite: {
    label: 'Interview invitation',
    subject: 'Next step: a conversation with Gleam Guru',
    body: (a) => `Hi ${a.first_name},\n\nThank you for applying to become a Guru. We'd like to invite you to an interview to talk about your availability, experience, and the opportunity.\n\nPlease reply with a few days and times that work for you, and let us know whether you prefer a phone or video call.\n\nGleam Guru Cleaners\n(971) 715-0335`,
  },
  rejection: {
    label: 'Not moving forward',
    subject: 'Your Gleam Guru application',
    body: (a) => `Hi ${a.first_name},\n\nThank you for taking the time to apply to Gleam Guru. After reviewing applications, we won't be moving forward with yours at this time.\n\nWe appreciate your interest and wish you the best in your search.\n\nGleam Guru Cleaners`,
  },
  offer: {
    label: 'Offer',
    subject: 'An offer from Gleam Guru Cleaners',
    body: (a) => `Hi ${a.first_name},\n\nWe enjoyed getting to know you through the interview and assessment, and we'd like to offer you a place on the Gleam Guru team.\n\nWe'll follow up with the details of the arrangement and next steps. Please reply to confirm you'd like to move forward.\n\nGleam Guru Cleaners\n(971) 715-0335`,
  },
  general: { label: 'General message', subject: '', body: () => '' },
};
